import { useEffect, useState } from 'react';
import { useAuth } from '@/context/AuthContext';
import { db } from '@/firebase';
import { 
  initializeRouteStatus, 
  subscribeToRouteStatus, 
  DEFAULT_ROUTE_STATUS 
} from '@/lib/routeStatusSync';

/**
 * Hook personalizado para sincronizar Estado de Ruta desde Firestore
 * Maneja:
 * - Carga inicial
 * - Suscripción con onSnapshot
 * - Limpieza de suscripción
 */
export function useRouteStatusSync(workspaceId) {
  const { user } = useAuth();
  const [routeStatus, setRouteStatus] = useState(DEFAULT_ROUTE_STATUS);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!workspaceId || !user) {
      setLoading(false);
      return;
    }

    let unsubscribe = null;
    let isMounted = true;

    const initialize = async () => {
      try {
        setLoading(true);
        setError(null);

        // Inicializar: cargar o crear documento
        const initialStatus = await initializeRouteStatus(workspaceId, db, user.uid);
        if (isMounted) {
          setRouteStatus(initialStatus);
        }

        // Suscribirse a cambios en tiempo real
        unsubscribe = subscribeToRouteStatus(workspaceId, db, (newStatus) => {
          if (isMounted) {
            setRouteStatus(newStatus);
          }
        });
      } catch (err) {
        console.error("[useRouteStatusSync] Error:", err);
        if (isMounted) {
          setError(err);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    initialize();

    // Cleanup
    return () => {
      isMounted = false;
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [workspaceId, user]);

  return { routeStatus, loading, error };
}
